import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { atLeastOne } from '../../../../../../../../../../@flamingo/validator/at-least-one.validator';
import {
  CompanyImport,
  CompanyImportResponse,
  JobStatus,
} from '../../../../../../../../../core/model/company-import-text.model';
import { TransferType } from '../../../../../../../../../core/model/transfer-type.model';

@Component({
  selector: 'app-massive-company-import-update',
  templateUrl: './massive-company-import-update.component.html',
  styleUrls: ['./massive-company-import-update.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MassiveCompanyImportUpdateComponent implements OnChanges {

  @Input() jobStatus!: CompanyImportResponse;
  @Output() formReady = new EventEmitter<UntypedFormGroup>();

  form: UntypedFormGroup;
  displayedColumns: string[] = [
    'businessName',
    'taxCode',
    'transferType',
    'existingInvoiceTotalAmount',
    'trustRequired',
  ];
  dataSource = new MatTableDataSource<AbstractControl>();

  readonly transferTypes: string[] = Object.keys(TransferType);
  readonly TransferType = TransferType;

  get relatedCompanies(): UntypedFormArray {
    return this.form.get('relatedCompanies') as UntypedFormArray;
  }

  constructor(
    private _formBuilder: UntypedFormBuilder,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.jobStatus && changes.jobStatus.currentValue.status === JobStatus.COMPLETED) {
      this.form = this._formBuilder.group({
        jobId: new UntypedFormControl(this.jobStatus.id),
        relatedCompanies: new UntypedFormArray([]),
      });

      this.jobStatus.output.relatedCompanies.forEach((company: CompanyImport) => {
        const control: UntypedFormGroup = new UntypedFormGroup({
            businessName: new UntypedFormControl(company.businessName),
            taxCodePrefix: new UntypedFormControl(company.taxCodePrefix),
            taxCode: new UntypedFormControl(company.taxCode),
            transferType: new UntypedFormControl(company.transferType || TransferType.ProSolutoConfirmNotification, Validators.required),
            existingInvoiceTotalAmount: new UntypedFormControl(company.existingInvoiceTotalAmount || null),
            trustRequired: new UntypedFormControl(company.trustRequired || null),
          },
          { validators: atLeastOne(Validators.required, ['existingInvoiceTotalAmount', 'trustRequired']) },
        );

        this.relatedCompanies.push(control);
      });

      this.dataSource.data = this.relatedCompanies.controls;

      this.formReady.emit(this.form);
    }
  }
}
